import ApiService from "@/api/ApiService";
import {
  StoffstromOrder,
} from "@/components/planning/Project";
import ConfirmDialog from "@/shared/dialogs/ConfirmDialog";
import {
  Delete,
  Edit,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Fragment } from "react";
import AddStoffstromDialog from "../planning/dialogs/AddStoffstromDialog";

export function DirectStoffstromEditor({
  order,
  plannedStart,
  plannedEnd,
}: {
  order: StoffstromOrder;
  plannedStart: string;
  plannedEnd: string;
}) {
  const queryClient = useQueryClient();

  const saveMutation = useMutation<
    StoffstromOrder,
    AxiosResponse,
    StoffstromOrder
  >({
    mutationFn: ApiService.editEntity("stoffstromEntry"),
    onSuccess: (answer) => {
      queryClient.invalidateQueries({
        queryKey: ["stoffstrom"],
      });
    },
  });

  return true ? (
    <Fragment>
      <AddStoffstromDialog
        save={function (order: StoffstromOrder): void {
          saveMutation.mutate({ ...order });
        }}
        OpenButton={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <Edit fontSize="small" />
          </IconButton>
        )}
        initialState={order}
        plannedStart={plannedStart}
        plannedEnd={plannedEnd}
      />
      <ConfirmDialog
        CustomButton={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <Delete fontSize="small" />
          </IconButton>
        )}
        title={"Wirklich löschen?"}
        confirmText={"Bitte bestätige die Löschung."}
        onAccept={() => saveMutation.mutate({ ...order, deleted: true })}
      />
    </Fragment>
  ) : null;
}
